import React from 'react';
import { connect } from 'react-redux';
import { mapStateToProps, mapDispatchToProps } from '../Store';
import { getCMSObject, TeleScript } from 'sg-ui-components';

import Layout from '../Components/Layout/Layout';
import PageTitle from '../Components/PageTitle.js';
import Entries from '../Components/Enter/Entries';

import UserLockout from '../userLockout';

const MyEntriesPage = ({ user, config, cmsSourceFirebase, actions }) => {
    const page = {
        title: getCMSObject('data.microsite.general.myEntries.pageInfo.pageTitle'),
        className: 'entries',
    };

    return (
        <Layout {...{ page, user, config, cmsSourceFirebase, actions }}>
            <UserLockout>
                <div className='page-info'>
                    <PageTitle title={page?.title} />
                    <div className='description'>
                        <TeleScript line={getCMSObject('data.microsite.general.myEntries.pageInfo.pageDescription.contentHTML')} />
                    </div>
                    <div className='text-center'>
                        <TeleScript line={getCMSObject('data.microsite.general.myEntries.ticketEntryInstruction.contentHTML')} />
                    </div>
                </div>
                <div className='entries-container w-100'>
                    <Entries />
                </div>
            </UserLockout>
        </Layout>
    );
};

export default connect(mapStateToProps, mapDispatchToProps)(MyEntriesPage);
